import { render, staticRenderFns } from "./dispatcherInfo.vue?vue&type=template&id=1da30c46&scoped=true"
import script from "./dispatcherInfo.vue?vue&type=script&lang=js"
export * from "./dispatcherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da30c46",
  null
  
)

export default component.exports